// src/common/utils/functions/isPointInPolygon.ts

type Point = { lat: number | string; lng: number | string };

export const isPointInPolygon = (point: Point, polygon: Point[]): boolean => {
  if (!polygon || polygon.length < 3) return false;

  const x = Number(point.lng);
  const y = Number(point.lat);

  if (isNaN(x) || isNaN(y)) return false;

  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = Number(polygon[i].lng);
    const yi = Number(polygon[i].lat);
    const xj = Number(polygon[j].lng);
    const yj = Number(polygon[j].lat);

    if (isNaN(xi) || isNaN(yi) || isNaN(xj) || isNaN(yj)) continue;

    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;

    if (intersect) inside = !inside;
  }

  return inside;
};
